import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPrefixColored = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="url(#PrefixColored_svg__a)"
      d="M8.365 1.932c.026-.08.105-.132.211-.132a.2.2 0 0 1 .186.132l.37 1.001 1.006.369c.08.026.132.105.132.184 0 .106-.053.185-.132.211l-1.006.37-.37.974a.2.2 0 0 1-.186.132c-.106 0-.185-.053-.211-.132l-.371-.975-1.006-.369c-.08-.026-.106-.105-.106-.21 0-.08.027-.159.106-.185l1.006-.369.37-1.001Zm4.738.263c.503-.5 1.297-.5 1.8 0l.9.896c.503.5.503 1.292 0 1.792L5.717 14.924a1.266 1.266 0 0 1-1.8 0l-.9-.896a1.253 1.253 0 0 1 0-1.792zm.9 1.186-2.78 2.767.61.606 2.779-2.767zM1.985 4.91l1.509-.58.556-1.476c.026-.132.159-.21.291-.21.106 0 .238.078.265.21l.582 1.476 1.482.58c.133.026.212.158.212.263 0 .132-.08.264-.212.29l-1.482.553-.582 1.503c-.027.105-.16.184-.265.184-.132 0-.265-.079-.291-.184l-.556-1.503-1.509-.553c-.132-.026-.185-.158-.185-.29 0-.105.053-.237.185-.263m9.318 6.746 1.509-.58.556-1.475c.026-.132.158-.211.29-.211.107 0 .239.079.265.21l.583 1.476 1.482.58a.28.28 0 0 1 .212.264c0 .132-.08.263-.212.29l-1.482.553-.583 1.502c-.026.106-.159.185-.264.185-.133 0-.265-.08-.292-.185l-.555-1.502-1.51-.553c-.132-.027-.184-.158-.184-.29 0-.106.052-.237.185-.264"
    />
    <defs>
      <linearGradient
        id="PrefixColored_svg__a"
        x1={1.8}
        x2={16.486}
        y1={3.937}
        y2={4.453}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A14CE4" />
        <stop offset={1} stopColor="#236AF3" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgPrefixColored;
